import{__exports as e}from"../../../../../_virtual/wait.js";Object.defineProperty(e,"__esModule",{value:!0}),e.wait=void 0,e.wait=async function(e){return new Promise((t=>setTimeout(t,e)))};export{e as default};
